/*    
<summary>
  This functional component "ConfirmPopupHOC" provides props to the child component.
  1. State "showConfirmPopup" that manages the show/hide of pop up
  2. Function "ConfirmPopupToggleHandler" to toggle the show/hide popup state "showConfirmPopup"
  Developer:Aashish Singh, Created Date:05-Sept-2023
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const FilteredDeviceDeletePopupHOC = (Component:any) => 
function Comp(props:any){
    const [showFilteredDeviceDeletePopup,setShowFilteredDeviceDeletePopup] = useState<boolean>(false);

    const filteredDeviceDeleteToggleHandler = () => {
        setShowFilteredDeviceDeletePopup(!showFilteredDeviceDeletePopup);
    }
	
	return <Component showFilteredDeviceDeletePopup={showFilteredDeviceDeletePopup} filteredDeviceDeleteToggleHandler={filteredDeviceDeleteToggleHandler} {...props}/>;
};

export default FilteredDeviceDeletePopupHOC;   